import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 pl-1 text-end x-small"
}

import { computed } from 'vue';
import i18n from '@/lang/i18n';

type statusType = {
  [key: string]: {
    class: string;
    label: string;
  };
};


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusBadge',
  props: {
    status: {},
    hasMessage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const label = computed(() => {
  return statuses[props.status]?.label ?? '';
});
const className = computed(() => {
  return statuses[props.status]?.class ?? '';
});

const subMessage = computed(() => {
  return props.hasMessage ?
    i18n.global.t('pages.downloadData.messages.clickForDetails') :
    '';
});

const statuses: statusType = {
  failed: { class: 'bg-danger text-white', label: i18n.global.t('pages.downloadData.messages.failed') },
  running: { class: 'bg-info', label: i18n.global.t('pages.downloadData.creating') },
  waiting: { class: 'bg-info', label: i18n.global.t('pages.downloadData.creating') },
  success: { class: 'bg-success', label: i18n.global.t('pages.downloadData.createComplate') },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", {
      class: _normalizeClass(["m-0 text-center", className.value])
    }, _toDisplayString(label.value), 3),
    (props.hasMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(subMessage.value), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})